module.exports = "/assets/2f137a3be5f973b5785e19be71c8c884.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FI.png
// module id = 1370
// module chunks = 0